import { FunctionComponent } from 'react';
import { FlexContainer, FlexItem, MainContainer } from '@astrumu/ui-library';

export const HeaderSkeleton: FunctionComponent = () => (
  <MainContainer>
    <FlexContainer
      style={{
        gap: 10,
        padding: '25px 0',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <FlexItem
        style={theme => ({
          height: 60,
          width: 100,
          transition: 'all 0.2s ease',
          background: theme.contourColor,
          borderRadius: 4,
          animation: 'ga-opacity 1s steps(5, end) infinite',

          '@media (min-width: 768px)': {
            width: 150
          },

          '@media (min-width: 1024px)': {
            width: 175
          }
        })}
      />

      <FlexContainer style={{ gap: 10 }}>
        <FlexItem
          style={theme => ({
            height: 50,
            width: 50,
            transition: 'all 0.2s ease',
            background: theme.contourColor,
            borderRadius: 4,
            animation: 'ga-opacity 1s steps(5, end) infinite',

            '@media (min-width: 768px)': {
              width: 250
            }
          })}
        />
        <FlexItem
          style={theme => ({
            height: 50,
            width: 200,
            transition: 'all 0.2s ease',
            background: theme.contourColor,
            borderRadius: 4,
            animation: 'ga-opacity 1s steps(5, end) infinite'
          })}
        />
      </FlexContainer>
    </FlexContainer>
  </MainContainer>
);
